import React, {useCallback} from 'react';
import {useParams} from 'react-router';
import {useSearchParams} from 'react-router';
import {useComponentForQueryResult} from 'src/hooks/UseComponentForQueryResult';
import {useSaasFromIdentifier, UserConfigTable} from 'src/components/common/Tables/UserConfigTable';
import {searchParamKeys} from 'src/routes';
import {cacheKeyForExternalUsers} from 'src/services/shared/serviceConstants';
import {
  getExternalUsers,
} from 'src/services/UserAccessExceptions';
import {privilegeStringFromCode} from 'src/utils/constants';
import {useQueryWithAccessToken} from "src/hooks/TanstackHooks";

export const ExternalUserPage = () => {
  const documentTitle = 'External Users - Detexian';
  document.title = documentTitle;

  const {saasIdentifier} = useParams<{ saasIdentifier?: string }>();
  const [searchParams] = useSearchParams();

  const privilegeCode = searchParams.get(searchParamKeys.privilege);
  const privilegeString = privilegeStringFromCode(privilegeCode);

  const cacheKey = cacheKeyForExternalUsers({
      saasIdentifier,
      privilegeCode
    })

  const queryResult = useQueryWithAccessToken({
      queryKey: [cacheKey],
      queryFunction: getExternalUsers,
      queryFunctionVariables: {
        saasIdentifier,
        privilegeLevel: privilegeString
      }
    }
  );

  const saas = useSaasFromIdentifier(saasIdentifier);

  const pageLoadFunction = useCallback(
    () => {
      return <UserConfigTable
        heading={`External ${privilegeString}s (${queryResult.data.length})`}
        users={queryResult.data}
        // connectedSaases={connectedSaases}
        saas={saas}
        shouldShowPrivilegeColumn={false}
      />
    },
    [privilegeString, queryResult.data, saas]
  );

 return useComponentForQueryResult({
    queryResult,
    pageLoadFunction,
    userErrorMessage: 'error accessing External Users',
  })
};
